// extracted by mini-css-extract-plugin
export default {"cls1":"TypeWriter-cls1__db9644b5ddf715b10731","cls2":"TypeWriter-cls2___ed669656672771ba23c TypeWriter-cls1__db9644b5ddf715b10731"};